import { useState } from "react";
import styles from "./AAQIIPage.module.css";
import Button from "../../components/common/Button";

const ITEMS = [
  "Minhas experiências e memórias dolorosas dificultam que eu viva uma vida que valorizo.",
  "Tenho medo dos meus sentimentos.",
  "Preocupo-me com não conseguir controlar minhas preocupações e sentimentos.",
  "Minhas memórias dolorosas me impedem de ter uma vida plena.",
  "Emoções dolorosas me impedem de fazer coisas importantes.",
  "Parece que a maioria das pessoas lida melhor com a vida do que eu.",
  "Minhas preocupações atrapalham meu sucesso.",
];

export default function AAQIIPage() {
  const [answers, setAnswers] = useState(Array(ITEMS.length).fill(null));
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (index, value) => {
    const updated = [...answers];
    updated[index] = value;
    setAnswers(updated);
  };

  const allAnswered = answers.every((a) => a !== null);

  const score = answers.reduce((sum, v) => sum + (v || 0), 0);

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1>AAQ-II</h1>
        <p>
          Esta escala avalia padrões relacionados à esquiva experiencial e à
          inflexibilidade psicológica. Ela não possui finalidade diagnóstica e
          deve ser interpretada de forma contextual.
        </p>
      </header>

      {!submitted && (
        <form className={styles.form}>
          {ITEMS.map((item, index) => (
            <div key={index} className={styles.item}>
              <p className={styles.statement}>{item}</p>

              <div className={styles.scale}>
                {[1, 2, 3, 4, 5, 6, 7].map((value) => (
                  <label key={value} className={styles.option}>
                    <input
                      type="radio"
                      name={`item-${index}`}
                      value={value}
                      checked={answers[index] === value}
                      onChange={() => handleChange(index, value)}
                    />
                    {value}
                  </label>
                ))}
              </div>
            </div>
          ))}

          <Button
            disabled={!allAnswered}
            onClick={(e) => {
              e.preventDefault();
              setSubmitted(true);
            }}
          >
            Ver resultado
          </Button>
        </form>
      )}

      {submitted && (
        <section className={styles.result}>
          <h2>Resultado</h2>

          <p className={styles.score}>
            Pontuação total: <strong>{score}</strong>
          </p>

          <p className={styles.interpretation}>
            Esta pontuação sugere, neste momento, maior ou menor tendência a
            padrões de esquiva experiencial e inflexibilidade psicológica.
            Resultados mais elevados indicam que experiências internas difíceis
            podem estar exercendo maior influência sobre as escolhas e ações
            cotidianas.
          </p>

          <p className={styles.note}>
            Este resultado não define quem você é, nem explica sua história. Ele
            pode servir como ponto de partida para reflexão e diálogo no
            processo terapêutico.
          </p>

          <Button onClick={() => setSubmitted(false)}>Refazer escala</Button>
        </section>
      )}
    </div>
  );
}
